import $ from 'jquery';

export const updateNavbarItemVisibility = (selectors = []) => {
  selectors.forEach((sel) => {
    const $btn = $(sel);
    if (!$btn.length) return;
    const $li = $btn.closest('li.nav-item');
    if (!$li.length) return;

    // Decide visibility based on the button's own intent (class/inline style),
    // not computed visibility (which is affected by parent <li> state).
    const hiddenByClass = $btn.hasClass('d-none');
    const hiddenByInline = ($btn[0]?.style?.display || '') === 'none';
    const shouldShow = !hiddenByClass && !hiddenByInline;

    if (shouldShow) {
      $li.show();
    } else {
      $li.hide();
    }
  });
};

// Convenience: run an initial pass on DOM ready
$(function () {
  updateNavbarItemVisibility(['#giotto-video-preview', '#editor-menu-print']);
});
